import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { logout } from '../../redux/actions';
import { FaHome, FaFileAlt, FaSearch, FaHistory, FaCalendarAlt, FaUserCog, FaSignOutAlt, FaBars, FaLaptopCode, FaTools, FaChevronDown, FaTicketAlt, FaShieldAlt, FaTrashAlt } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './Sidebar.module.css';
import Dropdown from 'react-bootstrap/Dropdown';

const Sidebar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const usuario = useSelector(state => state.usuario);
    const roleId = usuario.usuario.rolid;
    const areaid = usuario.usuario.areaid
    const [isOpen, setIsOpen] = useState(false);
    const [ticketsExpanded, setTicketsExpanded] = useState(false);
    const [tecnicoExpanded, setTecnicoExpanded] = useState(false);
    const adminis = usuario?.usuario?.adminis;

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
    };

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const handleLinkClick = () => {
        setIsOpen(false);
    };

    const handleNavigate = (path) => {
        navigate(path);
        setIsOpen(false);
    };

    return (
        <>
            <button className={styles.menuButton} onClick={toggleSidebar}>
                <FaBars />
            </button>
            <div className={`${styles.sidebarWrapper} ${isOpen ? styles.open : ''}`}>
                <div className={styles.sidebarHeader}>
                    <div className={styles.logoContainer}>
                        <div className={styles.logoIcon}>S</div>
                        <span className={styles.sidebarHeading}>SIGESTIC</span>
                    </div>
                </div>

                <div className={styles.userInfo}>
                    <div className={styles.userAvatar}>
                        {usuario?.usuario?.nombre?.charAt(0) || "U"}
                    </div>
                    <div className={styles.userDetails}>
                        <p className={styles.userName}>{usuario?.usuario?.nombre || "Usuario"}</p>
                        <p className={styles.userRole}>{roleId === 1 ? "Administrador" : "Usuario"}</p>
                    </div>
                </div>

                <nav className={styles.navMenu}>
                    <Link to="/home" className={`${styles.navLink} ${window.location.pathname === '/home' ? styles.active : ''}`} onClick={handleLinkClick}>
                        <div className={styles.iconWrapper}><FaHome /></div>
                        <span>Inicio</span>
                    </Link>

                    {/* GRUPO: GESTIÓN DE TICKETS */}
                    <div className={`${styles.expandableSection} ${ticketsExpanded ? styles.expanded : ''}`}>
                        <div className={styles.expandableHeader} onClick={() => setTicketsExpanded(!ticketsExpanded)}>
                            <div className={styles.headerTitle}>
                                <FaTicketAlt className={styles.headerIcon} />
                                <span>Gestión de Tickets</span>
                            </div>
                            <FaChevronDown className={styles.chevron} />
                        </div>

                        <div className={styles.expandableContent}>
                            <Dropdown className={styles.dropdownContainer}>
                                <Dropdown.Toggle as="div" className={styles.navLink}>
                                    <div className={styles.iconWrapper}><FaFileAlt /></div>
                                    <span>Generar Ticket</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className={styles.dropdownMenuCustom}>
                                    <Dropdown.Item onClick={() => handleNavigate('/generar-ticket')} className={styles.dropdownItem}>
                                        <FaLaptopCode className={styles.dropdownIcon} /> Gestión TI
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleNavigate('/generar-ticketmto')} className={styles.dropdownItem}>
                                        <FaTools className={styles.dropdownIcon} /> Mantenimiento
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            <Link to="/seguimiento-ticket" className={`${styles.navLink} ${window.location.pathname === '/seguimiento-ticket' ? styles.active : ''}`} onClick={handleLinkClick}>
                                <div className={styles.iconWrapper}><FaSearch /></div>
                                <span>Seguimiento</span>
                            </Link>

                            <Link to="/histtick" className={`${styles.navLink} ${window.location.pathname === '/histtick' ? styles.active : ''}`} onClick={handleLinkClick}>
                                <div className={styles.iconWrapper}><FaHistory /></div>
                                <span>Historial</span>
                            </Link>

                            <Link to="/agendamiento" className={`${styles.navLink} ${window.location.pathname === '/agendamiento' ? styles.active : ''}`} onClick={handleLinkClick}>
                                <div className={styles.iconWrapper}><FaCalendarAlt /></div>
                                <span>Agendador Sala</span>
                            </Link>
                        </div>
                    </div>

                    {/* GRUPO: PANEL TÉCNICO */}
                    {((roleId === 1 && areaid === 1 || areaid === 6) || adminis === 1) && (
                        <div className={`${styles.expandableSection} ${tecnicoExpanded ? styles.expanded : ''}`}>
                            <div className={styles.expandableHeader} onClick={() => setTecnicoExpanded(!tecnicoExpanded)}>
                                <div className={styles.headerTitle}>
                                    <FaShieldAlt className={styles.headerIcon} />
                                    <span>Panel Técnico</span>
                                </div>
                                <FaChevronDown className={styles.chevron} />
                            </div>

                            <div className={styles.expandableContent}>

                                {/* Técnico TI */}
                                {(roleId === 1 && areaid === 1) && (
                                    <Link
                                        to="/tecnico"
                                        className={`${styles.navLink} ${window.location.pathname === '/tecnico' ? styles.active : ''}`}
                                        onClick={handleLinkClick}
                                    >
                                        <div className={styles.iconWrapper}>
                                            <FaUserCog />
                                        </div>
                                        <span>Técnico TI</span>
                                    </Link>
                                )}

                                {/* Técnico MTO */}
                                {(roleId === 1 && areaid === 6) && (
                                    <Link
                                        to="/tecnicomto"
                                        className={`${styles.navLink} ${window.location.pathname === '/tecnicomto' ? styles.active : ''}`}
                                        onClick={handleLinkClick}
                                    >
                                        <div className={styles.iconWrapper}>
                                            <FaUserCog />
                                        </div>
                                        <span>Técnico MTO</span>
                                    </Link>
                                )}

                                {/* Administración */}
                                {adminis === 1 && (
                                    <Link
                                        to="/administ"
                                        className={`${styles.navLink} ${window.location.pathname === '/administ' ? styles.active : ''}`}
                                        onClick={handleLinkClick}
                                    >
                                        <div className={styles.iconWrapper}>
                                            <FaUserCog />
                                        </div>
                                        <span>Administración</span>
                                    </Link>
                                )}

                                {/* Dar de Baja Activos */}
                                {(adminis === 1 || usuario?.usuario?.permisoBaja === 1) && (
                                    <Link
                                        to="/darbaja"
                                        className={`${styles.navLink} ${window.location.pathname === '/darbaja' ? styles.active : ''}`}
                                        onClick={handleLinkClick}
                                    >
                                        <div className={styles.iconWrapper}>
                                            <FaTrashAlt />
                                        </div>
                                        <span>Dar de Baja Activos</span>
                                    </Link>
                                )}

                            </div>
                        </div>
                    )}
                </nav>

                <div className={styles.sidebarFooter}>
                    <button onClick={() => { handleLogout(); handleLinkClick(); }} className={styles.logoutButton}>
                        <FaSignOutAlt />
                        <span>Cerrar sesión</span>
                    </button>
                </div>
            </div>
            {isOpen && <div className={styles.overlay} onClick={toggleSidebar}></div>}
        </>
    );
};

export default Sidebar;
